/**
 * ZusatzEmployee.js – Bestandsmeldung mit Übergabe-Workflow (Task #104)
 * Nutzt die geteilte ZusatzReportingPanel-Komponente.
 */
import React from 'react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { ZusatzReportingPanel } from '../../components/ZusatzReportingPanel';

export const ZusatzEmployee = () => (
  <DashboardLayout>
    <div className="space-y-4 pb-8" data-testid="zusatz-employee-page">
      <div>
        <h1 className="text-2xl font-bold">Bestandsmeldung</h1>
        <p className="text-sm text-muted-foreground mt-1">Bestand zählen und Schicht protokollieren</p>
      </div>
      <ZusatzReportingPanel />
    </div>
  </DashboardLayout>
);
